import React from "react";
import Toast from "./Toast";
import { removeToastById } from "./Toaster.slice";
import { useAppDispatch, useAppSelector } from "../../shared/redux/hooks";

export const Toaster: React.FC = () => {
  const toasts = useAppSelector((state) => state.toaster.data);
  const dispatch = useAppDispatch();

  return (
    <div
      aria-live="assertive"
      className="fixed z-[99999] inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
    >
      <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
        {toasts.map((toast) => (
          <Toast
            data={toast}
            key={toast.id}
            onDismiss={() => dispatch(removeToastById(toast.id))}
          />
        ))}
      </div>
    </div>
  );
};

export default Toaster;
